import workspaceQuery from '../../../graphql/queries/sales/ImportedBigCommerceOrderWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/ImportedBigCommerceOrderListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/ImportedBigCommerceOrderQuery.graphql';
import mutationQuery from '../../../graphql/mutations/sales/ImportedBigCommerceOrderMutation.graphql';
import fragment from '../../../graphql/fragments/sales/ImportedBigCommerceOrderFragment.graphql';
import aggregateQuery from '../../../graphql/queries/sales/ImportedBigCommerceOrderAggregateQuery.graphql';

import { workspace } from '../../../actions/sales/ImportedOrderWorkspaceAction';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const ImportedBigCommerceOrder: EntityType = {
  type: 'ImportedBigCommerceOrder',
  title: 'BigCommerce Orders',
  formTitle: 'Imported BigCommerce Order',
  workspaceUrl: '/Sales/Channel/ImportedBigCommerceOrder/Workspace/',
  formUrl: '/Sales/Channel/ImportedBigCommerceOrder/Details/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'orderReference',
  },
  fragment,
  aggregate: aggregateQuery,
  screenReference: 'IMPORTED_BIGCOMMERCE_ORDERS',
  actions: workspace,
  operations: ALLOW_VIEW,
};

export default ImportedBigCommerceOrder;
